import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>{t("header.companyName")}</h3>
          <p>{t("footer.companyInfo")}</p>
        </div>
        
        <div className="footer-section">
          <h3>{t("contact.quickContact.title")}</h3>
          <p>📞 {t("contact.quickContact.phone1")}</p>
          <p>📞 {t("contact.quickContact.phone2")}</p>
          <p>✉️ {t("contact.quickContact.email1")}</p>
        </div>
        
        <div className="footer-section">
          <h3>{t("contact.workHours.title")}</h3>
          <p>{t("contact.workHours.saturday")}: {t("contact.workHours.time")}</p>
          <p>{t("contact.workHours.sunday")}: {t("contact.workHours.time")}</p>
          <p>{t("contact.workHours.monday")}: {t("contact.workHours.time")}</p>
          <p>{t("contact.workHours.tuesday")}: {t("contact.workHours.time")}</p>
          <p>{t("contact.workHours.wednesday")}: {t("contact.workHours.time")}</p>
          <p>{t("contact.workHours.thursday")}: {t("contact.workHours.time")}</p>
          <p className="closed">{t("contact.workHours.friday")}: {t("contact.workHours.closed")}</p>
        </div>
        
        <div className="footer-section">
          <h3>{t("contact.address.title")}</h3>
          <p>📍 {t("contact.address.full")}</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>{t("footer.rights", { year: currentYear })}</p>
        <Link to="/privacy-policy" className="footer-privacy-link">
          {t("footer.privacyPolicy")}
        </Link>
      </div>
    </footer>
  );
}
